import React, { FunctionComponent } from "react"
import { FormControl, OverlayTrigger, Popover } from "react-bootstrap"
import EALAService from "../../Utils/EALAService"
import ClientPortalEmployeeAccessLevelAreaTypes from "../../Types/ClientPortalEmployeeAccessLevelAreaTypes"
import "./EALATableItemTitle.css"
interface Props {
    manageParentState: Function
    AccessLevelID: number
    IsDefault: number
    ProfitCenterLongDesc: null | string
    ServiceAreaLongDesc: null | string
    StateName: null | string
    isNaughty: boolean
    eala: ClientPortalEmployeeAccessLevelAreaTypes
}

const EALATableItemTitle: FunctionComponent<Props> = (props) => {

    const { manageParentState, AccessLevelID, IsDefault, ProfitCenterLongDesc, StateName, ServiceAreaLongDesc, isNaughty, eala } = props
    const { lookupHashTableItem, checkForDropEala } = EALAService
    const littleText = (AccessLevelID === 40 || AccessLevelID === 50) ? ServiceAreaLongDesc : AccessLevelID === 30 ? ProfitCenterLongDesc : (AccessLevelID === 20 || AccessLevelID === 1) ? StateName : "NA"

    // console.log("EALATableItemTitle props", props)

    const EALATableItemTitleLittlePopover = (
        <Popover id={"eala-table-item-title-little-popover"}>
            <Popover.Content>
                {(StateName || ProfitCenterLongDesc || ServiceAreaLongDesc) &&
                    <div className="EALATableItemTitlePopoverHasData">
                        {StateName &&
                            <div className="EALATableItemTitlePopoverItem">
                                <p className="EALATableItemTitlePopoverItemText">{StateName}</p>
                                {ProfitCenterLongDesc && <span className="material-icons EALATableItemTitlePopoverArrow EALATableItemTitlePopoverArrow1">turn_right</span>}
                            </div>}
                        {ProfitCenterLongDesc &&
                            <div className="EALATableItemTitlePopoverItem">
                                <p className="EALATableItemTitlePopoverItemText">{ProfitCenterLongDesc}</p>
                                {ServiceAreaLongDesc && <span className="material-icons EALATableItemTitlePopoverArrow EALATableItemTitlePopoverArrow2">turn_right</span>}
                            </div>}
                        {ServiceAreaLongDesc &&
                            <div className="EALATableItemTitlePopoverItem EALATableItemTitlePopoverItemLast">
                                <p className="EALATableItemTitlePopoverItemText">{ServiceAreaLongDesc}</p>
                                {IsDefault > 0 && <div className="EALATableItemTitlePopoverItemTextDefaultDecorator"></div>}
                            </div>}
                    </div>}
            </Popover.Content>
        </Popover>
    )

    // console.log("EALATableItemTitle props", props)

    return (
        <div className="EALATableItemTitle"
            onClick={() => {
                let bucketItem = lookupHashTableItem("ealaTable", eala.EmployeeAccessLevelAreaID)
                if (bucketItem && IsDefault < 1 && !isNaughty) {
                    bucketItem[2].drop = !bucketItem[2].drop
                    manageParentState([])
                }
            }}
        >
            <FormControl
                checked={checkForDropEala(eala)}
                onChange={() => null}
                type="checkbox"
                disabled={eala.IsDefault > 0 || isNaughty}
            />
            <span className="material-icons">{eala.IsDefault ? "home" : "alt_route"}</span>

            <div className="EALATableItemTitleBig">
                {(StateName || ProfitCenterLongDesc || ServiceAreaLongDesc) &&
                    <div className="EALATableItemTitleBigHasData">
                        {StateName &&
                            <div className="EALATableItemTitleBigItem">
                                <p className="EALATableItemTitleBigItemText">{StateName}</p>
                                {ProfitCenterLongDesc && <span className="material-icons EALATableItemTitleBigArrow EALATableItemTitleBigArrow1">arrow_forward</span>}
                            </div>}
                        {(ProfitCenterLongDesc || StateName) &&
                            <div className="EALATableItemTitleBigItem">
                                <p className="EALATableItemTitleBigItemText">{ProfitCenterLongDesc}</p>
                                {ServiceAreaLongDesc && <span className="material-icons EALATableItemTitleBigArrow EALATableItemTitleBigArrow2">arrow_forward</span>}
                            </div>}
                        {ServiceAreaLongDesc &&
                            <div className="EALATableItemTitleBigItem EALATableItemTitleBigItemLast">
                                <p className="EALATableItemTitleBigItemText">{ServiceAreaLongDesc}</p>
                                {IsDefault > 0 && <div className="EALATableItemTitleBigItemTextDefaultDecorator"></div>}
                            </div>}
                    </div>}
            </div>
            <div className="EALATableItemTitleLittle">
                <p>{littleText}</p>
                <OverlayTrigger placement="right" overlay={EALATableItemTitleLittlePopover}>
                    <span className="EALATableItemTitleLittleOverlayBtn material-icons">info</span>
                </OverlayTrigger>
            </div>
        </div>
    )
}

export default EALATableItemTitle